import { googleMapsLoader } from "../google_maps_loader"

// Use neighborhood type for submarkets (new Places API)
const NEIGHBORHOOD_TYPES = ["neighborhood"]

let predictionMapper = ({ placeId, text }) => {
  // Extract just the neighborhood name (first part before comma).
  // FormattableText.toString() is unreliable depending on how Maps JS loaded
  // (returns undefined even on current versions); read `.text`, fall back to toString().
  const fullText = text?.text || text?.toString?.() || ""
  const neighborhoodName = fullText.split(",")[0].trim()

  return {
    data: { place_id: placeId, name: neighborhoodName },
    optionText: fullText, // Show full address in dropdown
    selectionText: neighborhoodName, // Show just neighborhood name when selected
    imageUrl: null,
  }
}

export const neighborhoodSelector = {
  mounted() {
    // Ensure input is disabled when mounting
    this.el.querySelector("input")?.setAttribute("disabled", true)

    const extraParams = JSON.parse(this.el.dataset.extraParams || "{}")

    this.el.addEventListener("autocomplete:item-select", (e) => {
      this.pushEventTo(
        this.el,
        this.el.dataset.onSelect,
        Object.assign({}, extraParams, e.detail.data),
      )
    })

    this.el.addEventListener("input", (e) => {
      if (e.target.value == "") {
        this.pushEventTo(this.el, this.el.dataset.onClear, extraParams)
      }
    })

    // Pass the element so we can get fresh bias coordinates on each search
    initAutocomplete(this.el)
  },

  getLocationBias() {
    const lat = parseFloat(this.el.dataset.biasLat)
    const lng = parseFloat(this.el.dataset.biasLng)
    const radius = parseFloat(this.el.dataset.biasRadius || "50000") // Default 50km

    if (!isNaN(lat) && !isNaN(lng)) {
      return {
        circle: {
          center: { lat, lng },
          radius,
        },
      }
    }
    return null
  },
}

async function initAutocomplete(element) {
  const [
    { AutocompleteSessionToken, AutocompleteSuggestion },
    { LatLng, LatLngBounds },
  ] = await Promise.all([
    googleMapsLoader.importLibrary("places"),
    googleMapsLoader.importLibrary("core"),
  ])

  const autocompleteSessionToken = new AutocompleteSessionToken()

  window.fetchNeighborhoodsForAutocomplete = async (query) => {
    if (query == "") return []

    const requestParams = {
      input: query,
      sessionToken: autocompleteSessionToken,
      includedPrimaryTypes: ["neighborhood"],
    }

    // Get fresh location restriction from data attributes each time
    const lat = parseFloat(element.dataset.biasLat)
    const lng = parseFloat(element.dataset.biasLng)

    if (!isNaN(lat) && !isNaN(lng)) {
      // Create bounding box around the city
      const sw = new LatLng(lat - 0.5, lng - 0.5)
      const ne = new LatLng(lat + 0.5, lng + 0.5)
      requestParams.locationRestriction = new LatLngBounds(sw, ne)
    }

    const { suggestions } =
      await AutocompleteSuggestion.fetchAutocompleteSuggestions(requestParams)

    return suggestions.map((s) => s.placePrediction).map(predictionMapper)
  }

  // Enable inputs marked for autocomplete initialization
  enableNeighborhoodSelector()
}

const selectorQuery = '[data-neighborhood-autocomplete-init="true"]'
function enableNeighborhoodSelector() {
  document.querySelectorAll(selectorQuery).forEach((input) => {
    input.removeAttribute("disabled")
  })
}
